<template>
    <div id="edocgrid">
        <app-gridview 
            v-bind:parentData = "{
                tabHeaders: this.dataHeader,
                tabItems: this.dataItems,
                pageTitle: this.pageTitle,
                search: this.search,
                isDelete: true
            }"
            v-on:EditItem="editItemHandler($event)"
            v-on:DeleteItem="deleteItemHandler($event)"
            v-on:NewPressed="newRecordHandler"
        ></app-gridview>
    </div>
</template>
<script>
import moment from 'moment';
import GridView from '../../../components/common/GridView';

export default {
    components: {
        'app-gridview': GridView
    },

    data() {
        return {
            pageTitle: 'Role Assignment',
            dataHeader: [
                { text: this.$t('columns.actions'), value: 'action', sortable: false, width:'80px' },
                { text: this.$t('columns.role'), value: 'rolecode', width: '80px' },
                { text: this.$t('roleassignment.description'), value: 'roledesc', width: '120px' },
                { text: this.$t('roleassignment.holdername'), value: 'ownername', width: '150px' },
                { text: this.$t('roleassignment.holderstaffno'), value: 'ownerstaffno', width: '150px' },
                { text: this.$t('roleassignment.holdercompany'), value: 'owner_companyname', width: '150px' },
                { text: this.$t('columns.startdate'), value: 'startdate', width: '100px' },
                { text: this.$t('columns.enddate'), value: 'enddate', width: '100px' },
                { text: this.$t('columns.name'), value: 'name', width: '150px' },
                { text: this.$t('columns.staffno'), value: 'staffno', width: '100px' },
                { text: this.$t('columns.company'), value: 'compnyname', width: '150px' },
            ],
            dataItems: [],
            loading: false,
            errMsg: '',
            search: this.$route.params.search,
        }
    },

    methods: {
        getRoleAssignmentListHandler() {
            const vm = this;

            this.loading = !this.loading;

            this.$store.dispatch('get', {url: `/roleassignment/all/`})
                .then(function (res) {
                    vm.dataItems = res.data.rec;

                    for (let i = 0; i < vm.dataItems.length; i++) {

                        if (vm.dataItems[i].startdate) {
                            vm.dataItems[i].startdate = moment(vm.dataItems[i].startdate).format('YYYY-MM-DD');
                        }
                        if (vm.dataItems[i].enddate) {
                            vm.dataItems[i].enddate = moment(vm.dataItems[i].enddate).format('YYYY-MM-DD');
                        }

                    }

                    vm.loading = !vm.loading;
                })
                .catch(function (err) {
                    vm.errMsg = err;
                });

        },

        deleteItemHandler(item) {
            const vm = this;
            if (!this.CheckPermission(this.$route.meta.funcname, 'candelete')) {
                return false;
            }

            if (confirm(this.$t('roleassignment.deleteroleassignment'))) {
                this.$store.dispatch('delete', {
                    url: "/roleassignment/" + item.id + '/' + this.$store.getters.userId
                })
                .then((res) => {
                if (res.data.error) {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = res.data.error;
                } else {
                    window.location.reload();
                }
                })
                .catch((err) => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                });
            }
        },

        editItemHandler(item) {
            this.$router.push({name: 'roleassignmentedit', params: { id: item.id } });
        },

        newRecordHandler() {
            this.$router.push({name: 'roleassignmentnew'});
        }
    },

    mounted() {
        this.getRoleAssignmentListHandler();
    }
}
</script>